import React from 'react';
import TopNav from 'components/TopNav';



function DangerouslysetInner() {
  return (
    <div
      style={{
        overflow: 'auto',
        height: '100vh',
        backgroundColor: 'var(--white)',
        maxWidth: 560,
        margin: 'auto',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <TopNav name={'DangerouslysetInner'} hasBackIcon={true} dir={`${process.env.RAZZLE_PUBLIC_URL}/pre-register`} />
      <React.Fragment>
        <div className={`back_white_wrap align-top`}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div className="align-center mb-heading">
              <span className="stick-icon">&nbsp;</span>
              <span className="title font-4">新規会員登録</span>
            </div>
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: `<div 
                  style="font-size:14px; 
                  color: #7F7F7F; 
                  font-weight: 400"
                >
                  <span>下記の項目を記入して頂き登録完了して下さい。</span>
                    <br /> 
                  <span>携帯電話番号認証が完了すれば登録完了です。</span>
                </div>
                <div
                  style="text-align: center;
                  font-size:14px; 
                  color: #7F7F7F; 
                  font-weight: 400
                  "
                >
                  <p>
                    登録した時点で
                  <br />
                  <span>利用規約</span>および
                  <span>プライバシーポリシー</span>
                  <br />
                    に同意したものとみなします。
                  </p>
                  <p>
                    18歳未満の方は登録できません
                  <br />
                    登録後必ず年齢認証を行って下さい
                  </p>
                </div>
                `,
            }}
          ></div>
        </div>
      </React.Fragment>
    </div>
  );
}

export default DangerouslysetInner;
